<script setup>
import {useBookingStore} from "../../../Registration/stores/bookingStore";
import FormItem from "../../../Registration/components/FormItem.vue";

const booking  = useBookingStore();
const {id} = defineProps(['id']);

</script>

<template>
    <FormItem v-for="item in booking.companionItems" :group="'companions'" :group-id="id"  :item="item" :key="`${id}-${item.id}`" />
</template>

<style scoped>

</style>
